import tmhRequest from '@/config/tmhRequest'

export default {
  searchStoreProduct: function (data) {
    return tmhRequest({
      url: '/project/tmh/storeproduct/searchstoreproduct',
      method: 'post',
      params: data,
    })
  },
  searchListStoreProduct: function (data) {
    return tmhRequest({
      url: '/project/tmh/storeproduct/searchliststoreproduct',
      method: 'post',
      params: data,
    })
  },

  searchNoPlusStoreProduct: function (data) {
    return tmhRequest({
      url: '/project/tmh/storeproduct/searchnoplusstoreproduct',
      method: 'post',
      params: data,
    })
  },

  searchStoreProductCount: function (data) {
    return tmhRequest({
      url: '/project/tmh/storeproduct/searchstoreproductcount',
      method: 'post',
      data: data,
    })
  },
  searchStoreProductByPage: function (data) {
    return tmhRequest({
      url: '/project/tmh/storeproduct/searchstoreproductbypage',
      method: 'post',
      data: data,
    })
  },
  addStoreProduct: function (data) {
    return tmhRequest({
      url: '/project/tmh/storeproduct/addstoreproduct',
      method: 'post',
      data: data,
    })
  },
  editStoreProduct: function (data) {
    return tmhRequest({
      url: '/project/tmh/storeproduct/editstoreproduct',
      method: 'post',
      data: data,
    })
  },
  initStoreProduct: function (data) {
    return tmhRequest({
      url: '/project/tmh/storeproduct/initstoreproduct',
      method: 'post',
      params: data,
    })
  },
  multiEditStoreProduct: function (data) {
    return tmhRequest({
      url: '/project/tmh/storeproduct/multieditstoreproduct',
      method: 'post',
      data: data,
    })
  },
}


// WEBPACK FOOTER //
// ./src/api/tmh/project/storeproduct.js